<div class="c">
    <div class="border">
    <img class="icon" src="assets/images/done.png">
    <p style="padding-top: 40px;">{{publicservice.Texts.Texts['done1']}}</p><br>
    <!-- <p>{{publicservice.Texts.Texts['done2']}}</p> -->
    <p>در صورت قبول درخواست شما توسط یک راننده، می توانید مشخصات ایشان را در قسمت <a href="/user_app/history" style="font-style: normal;color: #7ec66a;font-weight: bold;">تبادلات</a> مشاهده فرمایید</p>
</div>

<div class="back-btn">
    <button mat-button type="button" class="back" (click)="backhome()">
        {{publicservice.Texts.Texts['done3']}}</button>
</div>

</div>
